<template>
  <div class="toast" :class="{ show: showToast }" v-if="toastMessage">
    {{ toastMessage }}
  </div>
</template>

<script>
import { useStore } from '../store';
import { mapState } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, ['showToast', 'toastMessage']),
  },
};
</script>

<style scoped>
.toast {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 12px 24px;
    border-radius: 25px;
    font-size: 16px;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.toast.show {
    opacity: 1;
}
</style>
